var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"indentation-blocks"},_vm._l((_vm.blocks),function(block){return _c('indentation-block',{key:block.headline,attrs:{"infos":block}})}))}
var staticRenderFns = []

export { render, staticRenderFns }